import { render, staticRenderFns } from "./SectionShopRecipe.vue?vue&type=template&id=f6cf6138&scoped=true&lang=pug&"
import script from "./SectionShopRecipe.vue?vue&type=script&lang=js&"
export * from "./SectionShopRecipe.vue?vue&type=script&lang=js&"
import style0 from "./SectionShopRecipe.vue?vue&type=style&index=0&id=f6cf6138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6cf6138",
  null
  
)

export default component.exports